import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, changeLanguage, t } = useLanguage();

  return (
    <div className="language-selector">
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-select"
        aria-label={t('common.language', 'Language')}
      >
        <option value="da">{t('common.danish', 'Danish')}</option>
        <option value="en">{t('common.english', 'English')}</option>
      
      </select>
    </div>
  );
};

export default LanguageSelector;

